// extracted by mini-css-extract-plugin
export default {"mainDiv":"Login_mainDiv__qMWOv","loginButton":"Login_loginButton__iy1xX"};